import { IconButton } from '@mui/material';

interface Props {
  disabled?: boolean;
  onClick: () => void;
  icon: JSX.Element;
}

export const CustomIconButton = ({ onClick, icon, disabled = false }: Props) => {
  return (
    <IconButton
      component="span"
      disabled={disabled}
      sx={{ p: 0.2 }}
      onClick={(e) => {
        onClick();
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {icon}
    </IconButton>
  );
};
